<template>
  <div class="pagination">
    <span
      class="mr-8"
      @mouseover="toggleArrowLeft"
      @mouseout="toggleArrowLeft"
      @click="emitClickPreviousPage">
      <img
        :src="images.arrowLeftBtn.src"
        class="circle">
    </span>
    <span class="button secondary-text">{{ pageLabel }}</span>
    <span
      class="ml-8"
      @mouseover="toggleArrowRight"
      @mouseout="toggleArrowRight"
      @click="emitClickNextPage">
      <img
        :src="images.arrowRightBtn.src"
        class="circle">
    </span>
  </div>
</template>

<script>

import imgArrowLeftBtn from '@/assets/images/icons/pagination/arrow-left-btn.svg';
import imgArrowLeftBtnMouseover from '@/assets/images/icons/pagination/arrow-left-btn-mouseover.svg';
import imgArrowRightBtn from '@/assets/images/icons/pagination/arrow-right-btn.svg';
import imgArrowRightBtnMouseover from '@/assets/images/icons/pagination/arrow-right-btn-mouseover.svg';

export default {
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    totalNumberOfPage: {
      type: Number,
      default: 5,
    },
  },
  data () {
    return {
      images: {
        arrowLeftBtn: {
          src: imgArrowLeftBtn,
        },
        arrowRightBtn: {
          src: imgArrowRightBtn,
        },
      },
    };
  },
  computed: {
    pageLabel () {
      return this.$i18n.t('common.pagination.label', {
        currentPage: this.currentPage, totalNumberOfPage: this.totalNumberOfPage,
      });
    },
  },
  methods: {
    toggleArrowLeft () {
      if (this.images.arrowLeftBtn.src === imgArrowLeftBtn) {
        this.images.arrowLeftBtn.src = imgArrowLeftBtnMouseover;
      } else {
        this.images.arrowLeftBtn.src = imgArrowLeftBtn;
      }
    },
    toggleArrowRight () {
      if (this.images.arrowRightBtn.src === imgArrowRightBtn) {
        this.images.arrowRightBtn.src = imgArrowRightBtnMouseover;
      } else {
        this.images.arrowRightBtn.src = imgArrowRightBtn;
      }
    },
    emitClickPreviousPage (e) {
      if (this.currentPage > 1) {
        this.$emit('click-previous', e);
      }
    },
    emitClickNextPage (e) {
      if (this.currentPage < this.totalNumberOfPage) {
        this.$emit('click-next', e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.circle {
  width: 19px;
  height: 19px;
  display: block;
}
.circle:hover {
  cursor: pointer;
}
.pagination {
  display: inline-flex;
  align-content: center;
  align-items: flex-end;
  height: 24px;
}

</style>
